import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ContactUsProfileService } from 'src/app/services/contact-us-profile.service';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent implements OnInit {

  registerForm: FormGroup;
  submitted = false;
  charcount;
  siteKey: string = environment.siteKey;
  public size: 'compact' | 'normal' = 'normal';
  alertBar: boolean;
  alertMsg: any;

  constructor(private formBuilder: FormBuilder, public sanitizer: DomSanitizer,
    private contantService: ContactUsProfileService) { }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]],
      comments: ['', Validators.required],
      recaptcha: ['', Validators.required]
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }

  onSubmit() {
    this.alertBar = false;
    console.log(this.registerForm.value, '=========', this.registerForm.value.recaptcha)
    this.submitted = true;
    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }
    this.contantService.createContactForm(this.registerForm.value).subscribe((resp: any) => {
      console.log(resp.status, 'resp')
      if (resp.status == 0) {
        this.alertBar = true;
        this.alertMsg = 'There was a problem submitting your enquiry. Please try again after some time.'
      } else {
        this.alertBar = true;
        this.alertMsg = 'You have submitted your details.'
      }
      console.log(resp.message, '=resp============= ');
    })
  }

  onReset() {
    this.submitted = false;
    this.registerForm.reset();
    this.charcount = null;
    this.registerForm.value.recaptcha = ''
  }

  returnDescription(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  };

  countChars = function (countfrom) {
    if (!countfrom) {
      this.charcount = 1000;
    }
    else {
      var len = countfrom.length;
      var left = 1000 - len;
      this.charcount = left;
    }
  }
}
